
import { defineComponent } from 'vue';
import Component from './Component.vue';
import { DeviceType } from "@/models/Blocks/Itens/Types/device-type";

export default defineComponent({
    name: 'mobile',
    extends: Component,
    computed: {
        device(){
            return DeviceType.mobile;
        }
    }
});
